import {axios} from '../../../lib'

export const getUsers = ({
                             searchTerm = null,
                             userRoles = null,
                             pageNumber = null,
                             size = null,
                             statuses = null,
                             orderByList = null
                         }) => {
    return axios.post('/users/paginate', {
        searchTerm,
        userRoles,
        statuses,
        pagination: {
            ...(pageNumber == null || size == null
                ? {pageNumber: null, size: null}
                : {pageNumber, size}),
            orderByList
        }
    })
}
